/** Tableau générique d'un rapport QuickBooks normalisé (colonnes + lignes section / data / summary, indentation par niveau). */
import { Empty } from "../../comptabilite/_shared";
import { TH, THead, Table } from "../../comptabilite/reports/_bits";
import { fmtCell } from "./_qbo";

const ROW_CLS = {
  section: "bg-slate-50/70 text-emerald-900 font-semibold",
  summary: "bg-slate-50 font-bold border-t border-slate-300",
  data: "hover:bg-emerald-50/40",
};

export default function QboReportTable({ part, testId }) {
  const cols = part.columns || [];
  if (!part.rows?.length) return <Empty text="Aucune donnée QuickBooks pour cette période" testId={`${testId}-empty`} />;
  return (
    <div className="overflow-x-auto" data-testid={testId}>
      <Table>
        <THead>{cols.map((c, i) => <TH key={i} right={c.numeric} className={i === 0 ? "" : "whitespace-nowrap"}>{c.title}</TH>)}</THead>
        <tbody className="divide-y">
          {part.rows.map((r, i) => (
            <tr key={i} className={ROW_CLS[r.type]} data-testid={`${testId}-row-${r.type}`}>
              {cols.map((c, j) => {
                const cell = r.cells[j] || { v: "" };
                if (j === 0) return <td key={j} className="py-1.5 pr-3 text-sm" style={{ paddingLeft: 12 + (r.level || 0) * 16 }}>{cell.v}</td>;
                return <td key={j} className={`px-3 py-1.5 text-sm whitespace-nowrap ${c.numeric ? "text-right font-mono tabular-nums" : "text-slate-600"}`}>{fmtCell(cell.v, c.numeric)}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
